import { AlignmentType, convertInchesToTwip, LevelFormat, Packer, PageOrientation, ImageRun, SectionType, Document, NumberFormat, VerticalAlign, TableCell, TableRow, BorderStyle, WidthType, Paragraph, Header, Table, Footer, PageNumber, TextRun, TableOfContents, TableLayoutType, TabStopType, HeadingLevel, ShadingType } from 'docx';
import { url } from '../../../../../../src/constants/url.js'
import homepageImage from '../../../../../Assests/ReportImages/isecurion1.png'
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { certinDesign, fontPageBlueImage, reportAppDate, } from '../../Web/CertIn/Part1/FrontPage.js';
import { reportAppName } from './Part1/FrontPage-Support.js';
import { documentHeading, documentFirstTable, documentHeading2, documentSecondTable } from './Part1/Page1-Support.js'
import { page2Heading, page2Heading2, page2secondTable } from '../../Web/CertIn/Part1/Page2-Support.js';
import { page2firstTable } from './Part1/Page2-Support.js'
import { TOCHeadings } from '../../Web/CertIn/Part1/Page3-Support.js';
import { aboutPage1, aboutPage2, aboutPage3, aboutPage4, bulletfive, bulletfour, bulletOne, bulletsix, bulletThree, bulletTwo } from '../../Web/CertIn/Part1/Page4-Support.js';
import { disclaimerPage1, disclaimerPage2, disclaimerPage4, disclaimerPage5 } from '../../Web/CertIn/Part1/Page5-Support.js';
import { disclaimerPage3 } from './Part1/Page5-Support.js'
import { overviewPage1, objectivePage1, objectiveBulletOne, objectiveBulletTwo, objectiveBulletThree, objectiveBulletFour, scopeHeading, scope1, scopeTable } from './Part1/Page6-Support.js'
import { summeryPage, summaryBulletOne } from './Part2/Page7-Support.js'
import { discoverymethodology, methodologyText, steps1BulletFour, steps1BulletOne, steps1BulletThree, steps1BulletTwo } from '../BlueFormat/Part1/Page7-Support.js';
import { areaCovered, areaCoveredText, coveredPoint1, coveredPoint2, coveredPoint3, coveredPoint4, coveredPoint5, coveredPoint6, coveredPoint7, coveredPoint8, framework, frameworkText, tools, toolsTable } from './Part2/Page9-Support.js'
import { barchartText, OWASPText1, OWASPText2 } from './Part2/Page10-Support.js';
import { owasptableText, top10ListTable } from './Part2/Page11-Support.js';
import { mappingTable, observationText1, observationText2 } from './Part2/Page12-Support.js';
import { exploitationTable, exploitationText, severityTable, severityText } from '../../Web/CertIn/Part2/Page14-Support.js';
import { graphText, piechartText, severityLevelTable, tableText } from '../../Web/CertIn/Part3/Page15-Support.js';
import { findingsText1 } from './Part2/Page15-Support.js'
import { stageText2 } from './Part3/Page16-Support.js';
import { stageText1, stageText3 } from '../../Web/CertIn/Part3/Page17-Support.js';
import { verificationTable } from '../../Web/CertIn/Part3/Page19-Support.js';
import { conclusionText1, conclusionText10, conclusionText2, conclusionText3, conclusionText4, conclusionText5, conclusionText6, conclusionText7, conclusionText8, conclusionText9 } from './Part3/EndPage-Support.js';
import { discoverymethodologyMobile, methodologyTextMobile, steps1BulletMobileFour, steps1BulletMobileOne, steps1BulletMobileThree, steps1BulletMobileTwo } from './Part2/Page8-Support.js';

export async function MobileCertInReportSkeleton(props) {
    const {
        date, customerName, author, clientName, consultantName, applicationName, applicationURL, testStartDate,
        testEndDate, environmentType, emailVer, logout, userRoles, critical, high, medium, low, info, vulCount,
        mobileOWASP, generatedReportData, pocDetails, loading, setLoading, textAreaValue, testingType,
        weakPoints, strongPoints, image, imageUrl, appDiscription
    } = props


    const reportName = `${applicationName} Security Audit Phase 1 Report of Mobile Application`;

    // front page Details
    const frontPage1 = certinDesign
    const frontPage2 = fontPageBlueImage
    const frontPage3 = reportAppName(applicationName)
    const FrontPage4 = reportAppDate(date)

    const page11 = documentHeading
    const page12 = documentFirstTable(applicationName)
    const page13 = documentHeading2
    const page14 = documentSecondTable(customerName, date)

    // page 2 details
    const page21 = page2Heading
    const page22 = page2firstTable(date)
    const page23 = page2Heading2
    const page24 = page2secondTable

    // page 3 Details
    const page31 = TOCHeadings

    // page 4 Details
    const page41 = aboutPage1
    const page42 = aboutPage2
    const page43 = aboutPage3
    const page44 = aboutPage4
    const page45 = bulletOne
    const page46 = bulletTwo
    const page47 = bulletThree
    const page48 = bulletfour
    const page49 = bulletfive
    const page50 = bulletsix


    // page 5 Details
    const page51 = disclaimerPage1(customerName) /* this is imported from the web certin */
    const page52 = disclaimerPage2 /* this is imported from the web certin */
    const page53 = disclaimerPage3(customerName)
    const page54 = disclaimerPage4 /* this is imported from the web certin */
    const page55 = disclaimerPage5 /* this is imported from the web certin */

    // page 6 details
    const page61 = overviewPage1(appDiscription)
    const page62 = objectivePage1(applicationName)
    const page63 = objectiveBulletOne(applicationName)
    const page64 = objectiveBulletTwo
    const page65 = objectiveBulletThree
    const page66 = objectiveBulletFour
    const page67 = scopeHeading
    const page68 = scope1(customerName)
    const page69 = scopeTable(applicationName)

    // page 7 details
    const page71 = summeryPage(customerName, applicationName)
    const page72 = summaryBulletOne(testEndDate, testStartDate)

    // page 8 details
    const page81 = methodologyTextMobile
    const page82 = steps1BulletMobileOne
    const page83 = steps1BulletMobileTwo
    const page84 = steps1BulletMobileThree
    const page85 = steps1BulletMobileFour
    const page86 = discoverymethodologyMobile

    //  page 9 Details

    const page91 = framework
    const page92 = frameworkText(applicationName)
    const page93 = tools
    const page94 = toolsTable
    const page95 = areaCovered
    const page96 = areaCoveredText
    const page97 = coveredPoint1
    const page98 = coveredPoint2
    const page99 = coveredPoint3
    const page100 = coveredPoint4
    const page911 = coveredPoint5
    const page912 = coveredPoint6
    const page913 = coveredPoint7
    const page914 = coveredPoint8

    // page 10 Details
    const page101 = barchartText
    const page102 = OWASPText1
    const page103 = OWASPText2

    // page 11 Details
    const page111 = owasptableText
    const page112 = top10ListTable(mobileOWASP)

    // page 12 Details
    const page121 = observationText1(applicationName, vulCount)
    const page122 = observationText2
    const page123 = mappingTable

    // page 13 Details
    const page131 = severityText /* this is imported from the web certin */
    const page132 = severityTable /* this is imported from the web certin */
    const page133 = exploitationTable /* this is imported from the web certin */

    // page 14 Details
    const page141 = graphText
    const page142 = severityLevelTable(critical, high, medium, low, info)
    const page143 = tableText
    const page144 = piechartText

    // page 15 Details
    const page151 = findingsText1

    // page 16 Details
    const page161 = stageText1 /* this is imported from the web certin */
    const page162 = stageText2
    const page163 = stageText3 /* this is imported from the web certin */

    // page 17 details
    const page181 = verificationTable

    // last page details
    const page191 = conclusionText1(applicationName)
    const page192 = conclusionText2
    const page193 = conclusionText3
    const page194 = conclusionText4
    const page195 = conclusionText5
    const page196 = conclusionText6
    const page197 = conclusionText7
    const page198 = conclusionText8
    const page199 = conclusionText9
    const page200 = conclusionText10(date)


    // logo 
    const imageData = await fetch(homepageImage).then(response => response.blob());
    const footerIsecurion = new ImageRun({
        type: 'png',
        data: await imageData.arrayBuffer(),
        transformation: {
            width: 225,
            height: 60
        },
    });




    const AboutHeading = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "About ISECURION",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const DisclaimerHeading = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Disclaimer",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const ApploicationOveriew = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Application Overview",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const Objectives = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Objectives and Scope",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const Executive = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Executive Summary",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const Methodology = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Methodology",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const Frameworkandtools = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Framework and tools used for Audit",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const BenchmarkingwithOWASP1 = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Benchmarking with OWASP TOP 10",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const ObservationSummary = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Observation Summary",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const cvssMapping = new Paragraph({
        spacing: { before: 350, after: 500 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 1 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "CVSS 3.1 MAPPING",
                size: 26,
                color: "c00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const easeOfExploitation = new Paragraph({
        spacing: { before: 350, after: 500 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 1 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Ease of Exploitation",
                size: 26,
                color: "c00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const overviewHeading = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Overview of Findings",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    //Detailed Stage 1 Findings and Recommendations
    const DetailedStage = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Detailed Stage 1 Findings and Recommendations",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const MethodsHeading = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Methods of verification to compliance with CERT-In Directions",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    //Conclusion
    const Conclusion = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Conclusion",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const design = {
        page: {
            margin: { header: 350, footer: 700 },
            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            type: SectionType.CONTINUOUS,
        },
    }
    const MAX_WIDTH = 670;
    const MAX_HEIGHT = 380;

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;

                // Calculate scaling factors for width and height
                const widthScale = MAX_WIDTH / width;
                const heightScale = MAX_HEIGHT / height;

                // Use the smaller scaling factor (to stay within both bounds)
                const scale = Math.min(widthScale, heightScale, 1);

                width = width * scale;
                height = height * scale;

                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            return new ImageRun({
                data: imageData,
                transformation: { width: 624, height: 300 },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    // client logo
    let clientImageRun;
    if (image) {
        try {
            const clientImageData = await getBase64(image)
            clientImageRun = new ImageRun({
                data: clientImageData,
                transformation: { width: 100, height: 25 }
            })
            console.log("Selected", clientImageRun);
        }
        catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            clientImageRun = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 100, height: 25 }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }

    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 6, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            indent: { left: 30, right: 30 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Sl. No",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    indent: { left: 600 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 27, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Name of Vulnerability",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 13, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 54, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Recommendations",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                })
            ],
        }),
    ];
    const sortVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);

    sortVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(riskScore) {
            let severity = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
            } else {
                severity = "Info";
            }
            return { severity };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity } = getSeverityAndColor(riskScore);

        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                indent: { left: 60 },
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerabilityName,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),

                    new TableCell({
                        width: { size: 53, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    indent: { left: 500, right: 50 },
                                    spacing: { before: 50, after: 50 },
                                    bullet: { level: 0 },
                                    alignment: AlignmentType.LEFT,
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                    ]
                                })
                            )

                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    })

                ],
            })
        );
    });

    // Vulnerability Table
    const sortedVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);
    const docSections = sortedVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];

        for (let i = 0; i < (vulnerability.poc || []).length; i++) {
            const pocText = vulnerability.poc[i]?.poc || "";
            const matchingPocDetails = pocDetails.find(
                (p) => p.data.vulId === vulnerability._id
            );
            combinedContent.push(
                new Paragraph({
                    children: [
                        new TextRun({
                            text: `${pocText}`,
                            size: 24,
                        }),
                    ],
                })
            );

            if (matchingPocDetails) {
                const pocFiles = matchingPocDetails.data.files || [];
                const currentPocFiles = pocFiles.filter(
                    (file) => file.pocFolder === `poc-${i}`
                );
                if (currentPocFiles.length > 0) {
                    for (let j = 0; j < currentPocFiles.length; j++) {
                        const file = currentPocFiles[j];
                        if (file.url) {
                            try {
                                const pocImageData = await fetchImageAsBase64(file.url);
                                const dimensions = await getImageDimensions(pocImageData);

                                const imageRun = new ImageRun({
                                    data: pocImageData.split(",")[1],
                                    transformation: {
                                        width: dimensions.width,
                                        height: dimensions.height,
                                    },
                                });
                                combinedContent.push(
                                    new Paragraph({
                                        spacing: { before: 200, after: 300 },
                                        children: [imageRun],
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    `Error fetching image for vulnerability`,
                                );
                            }
                        }
                    }
                } else {
                    console.log(
                        `No files found for vulnerability`
                    );
                }
            }
        }


        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
                color = "ffff00";
            } else {
                severity = "Informational";
                color = "00b050";
            }

            return { severity, color };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity, color } = getSeverityAndColor(riskScore);

        return [
            new Paragraph({
                pageBreakBefore: true,
                heading: HeadingLevel.HEADING_1,
                spacing: { before: 150, after: 200 },
                indent: { left: 600 },
                width: { size: 100, type: WidthType.PERCENTAGE },
                numbering: { reference: "my-crazy-numbering", level: 2 },
                children: [
                    new TextRun({
                        text: vulnerability.vulnerabilityName,
                        size: 24,
                        color: "000000",
                        font: "Calibri",
                        bold: true,
                        italics: false
                    })
                ],
            }),
            new Table({
                width: { size: 106, type: WidthType.PERCENTAGE },
                alignment: AlignmentType.LEFT,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },

                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Vulnerability",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,
                                        // indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerabilityName,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Description",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.JUSTIFIED,
                                    indent: { left: 100, right: 80 },
                                    children: [new TextRun({
                                        text: vulnerability.description,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "OWASP Category ",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true.valueOf,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    indent: { left: 100, right: 80 },
                                    alignment: AlignmentType.LEFT,
                                    // indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.OWASP,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected Application",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.affectedParameter.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 50, after: 50 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,

                                        children: [
                                            new TextRun({
                                                text: url,
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            })
                                        ]
                                    })
                                ),

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Risk/Impact",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    indent: { left: 100, right: 80 },
                                    alignment: AlignmentType.LEFT,
                                    // indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.risk,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Ease of Exploitation",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.exploitation,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS String",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.cvssString,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            // First cell: CVSS Score/ Risk Rating header
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: "CVSS Score/ Risk Rating",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            // Second cell: Risk score and severity
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: `${riskScore} / ${severity}`,
                                                font: "Calibri",
                                                size: 22,
                                                color: color,
                                                italics: false,
                                                bold: true
                                            })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            })
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation/ Solution",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                spacing: { before: 50, after: 50 },

                                children: [
                                    new Paragraph({
                                        indent: { left: 100, right: 80 },
                                        spacing: { before: 100, after: 100 },
                                        children: [
                                            new TextRun({
                                                text: "It is recommended to:",
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            indent: { left: 700, right: 80 },
                                            spacing: { before: 100, after: 100 },
                                            bullet: { level: 0 },
                                            children: [
                                                new TextRun({
                                                    text: bulletText.trim(),
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "000000",
                                                    italics: false
                                                })
                                            ]
                                        })
                                    )

                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100, right: 80 },
                                        children: [new TextRun({
                                            text: "",
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({ pageBreakBefore: true }),
            new Paragraph({
                spacing: { after: 200 },
                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "000000",
                        font: "Calibri",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })
    const docSectionsResolved = await Promise.all(docSections);

    let FrontPageClientLogo;

    if (image) {
        try {
            const clientImageData = await getBase64(image)
            FrontPageClientLogo = new ImageRun({
                transformation: { width: 220, height: 140 },
                data: clientImageData,
                floating: {
                    zIndex: 10,
                    horizontalPosition: { offset: 2090000 },
                    verticalPosition: { offset: 2500000 },
                }
            })
            console.log("Selected", FrontPageClientLogo);
        } catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            FrontPageClientLogo = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 220, height: 140 },
                floating: {
                    zIndex: 10,
                    horizontalPosition: { offset: 2090000 },
                    verticalPosition: { offset: 2500000 },
                }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }

    const doc = new Document({
        creator: "ISECURION",
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [
                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "%1.",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 26,
                                    bold: true,
                                    color: "c00000",
                                },
                            },
                        },
                        {
                            level: 1,
                            format: LevelFormat.DECIMAL,
                            text: "9.%2",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "#0f0f3f", bold: true, size: 24, font: "Calibri" },
                                run: {
                                    size: 26,
                                    bold: true,
                                    color: "c00000",
                                    font: "Cambria"
                                },
                            },
                        },
                        {
                            level: 2,
                            format: LevelFormat.DECIMAL,
                            text: "11.%3",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 24,
                                    bold: true,
                                    color: "0f0f3f",
                                    font: "Calibri"
                                },
                            },
                        },

                    ]
                }
            ]
        },
        features: { updateFields: true },
        styles: {
            default: {

                document: {
                    run: {
                        font: "Calibri",
                        bold: false,
                        size: 22,
                        color: "000000",
                    },
                },
                heading1: {
                    run: {
                        size: 26,
                        color: "C00000",
                        font: "Cambria",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading2: {
                    run: {
                        size: 26,
                        color: "C00000",
                        font: "Cambria",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading3: {
                    run: {
                        font: "Cambria",
                        size: 24,
                        bold: true,
                        color: "0f0f3f",
                        italics: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },

            },
        },
        sections: [
            {
                properties: { page: { margin: { top: 550, right: 0, bottom: -1400, left: 0 }, size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT }, pageNumbers: { start: 0, formatType: NumberFormat.DECIMAL }, } },
                children: [frontPage1, frontPage2, frontPage3, FrontPage4,
                    new Paragraph({
                        children: [FrontPageClientLogo]
                    })
                ]
            },
            {
                properties: {
                    page: {
                        margin: { header: 350, footer: 700 },
                        size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
                        type: SectionType.CONTINUOUS,
                    },
                },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                margin: { top: 400 },
                                width: { size: 110, type: WidthType.PERCENTAGE },
                                alignment: AlignmentType.LEFT,
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 50, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.LEFT, children: [footerIsecurion] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),

                                            new TableCell({
                                                width: { size: 50, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.RIGHT, children: [clientImageRun] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                margin: { top: 600 },
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [

                                            new TableCell({
                                                width: { size: 65, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Confidential 2026",
                                                                font: "Calibri",
                                                                size: 22,
                                                                italics: false,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 32, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Page",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 22,
                                                                bold: true,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 3, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 22,
                                                                bold: true,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                },

                children: [page11, page12, page13, page14],
                pageBreakBefore: true,
            },
            //---------------------- page 2 Start----------------------
            {
                properties: { ...design },
                children: [page21, page22, page23, page24],
                pageBreakBefore: true
            },
            //---------------------- page 2 End----------------------
            //---------------------- page 3 Start----------------------
            {
                properties: { ...design },
                children: [page31,
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        layout: TableLayoutType.FIXED,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        alignment: AlignmentType.LEFT,
                        // indent: { size: 500, type: WidthType.DXA },
                        rows: [
                            new TableRow({

                                children: [
                                    new TableCell({
                                        width: { size: 100, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TableOfContents("Table of Content", {
                                                        hyperlink: true,
                                                        headingStyleRange: "1-5",
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
                pageBreakBefore: true
            },
            //---------------------- page 3 End----------------------
            //---------------------- page 4 Start----------------------
            {
                properties: { ...design },
                children: [AboutHeading, page41, page42, page43, page44, page45, page46, page47, page48, page49, page50],
                pageBreakBefore: true
            },
            //---------------------- page 4 End----------------------
            //---------------------- page 5 Start----------------------
            {
                properties: { ...design },
                children: [DisclaimerHeading, page51, page52, page53, page54, page55],
                pageBreakBefore: true
            },
            //---------------------- page 5 End----------------------
            //---------------------- page 6 Start----------------------
            {
                properties: { ...design },
                children: [ApploicationOveriew, page61, Objectives, page62, page63, page64, page65, page66, page67, page68, page69],
                pageBreakBefore: true
            },
            // ---------------------- page 6 End----------------------
            //---------------------- page 7 Start----------------------
            {
                properties: { ...design },
                children: [Executive, page71, page72],
                pageBreakBefore: true
            },
            //---------------------- page 7 End----------------------
            //---------------------- page 8 Start----------------------
            {
                properties: { ...design },
                children: [Methodology, page81, page82, page83, page84, page85, page86,],
                pageBreakBefore: true
            },
            //---------------------- page 8 End----------------------
            //---------------------- page 9 Start----------------------
            {
                properties: { ...design },
                children: [Frameworkandtools, page91, page92, page93, page94, page95, page96, page97, page98, page99, page100, page911, page912, page913, page914],
                pageBreakBefore: true
            },
            //---------------------- page 9 End----------------------
            //---------------------- page 10 Start----------------------
            {
                properties: { ...design },
                children: [BenchmarkingwithOWASP1, page101, page102, page103],
                pageBreakBefore: true

            },
            //---------------------- page 10 End----------------------
            //---------------------- page 11 Start----------------------
            {
                properties: { ...design },
                children: [page111, page112],
                pageBreakBefore: true
            },
            //---------------------- page 11 End----------------------
            //---------------------- page 12 Start----------------------
            {
                properties: { ...design },
                children: [ObservationSummary, page121, page122, cvssMapping, page123,],
                pageBreakBefore: true
            },
            //---------------------- page 12 End----------------------
            //---------------------- page 13 Start----------------------
            {
                properties: { ...design },
                children: [page131, page132, easeOfExploitation, page133],

                pageBreakBefore: true
            },
            //---------------------- page 13 End----------------------
            //---------------------- page 14 Start----------------------
            {
                properties: { ...design },
                children: [page141, page142, page143, page144],
                pageBreakBefore: true
            },
            //---------------------- page 14 End----------------------
            //---------------------- page 15 Start----------------------
            {
                properties: { ...design },
                children: [overviewHeading, page151, new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    alignment: AlignmentType.CENTER,
                    spacing: { before: 1200 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    },
                    rows: rows
                })],
                pageBreakBefore: true
            },
            //---------------------- page 15 End----------------------
            //---------------------- page 16 Start----------------------
            {
                properties: { ...design },
                children: [DetailedStage, page161, page162, page163],
                pageBreakBefore: true
            },
            //---------------------- page 16 End----------------------
            //---------------------- page 17 Start----------------------
            {
                properties: { ...design },
                children: [...docSectionsResolved.flat()],
                pageBreakBefore: true
            },
            //---------------------- page 17 End----------------------
            //---------------------- page 18 Start----------------------
            {
                properties: { ...design },
                children: [MethodsHeading, page181],
                pageBreakBefore: true
            },
            //---------------------- page 18 End----------------------
            //----------------------Conclusion page Start ----------------------
            {
                properties: { ...design },
                children: [Conclusion, page191, page192, page193, page194, page195, page196, page197, page198, page199, page200],
                pageBreakBefore: true
            }
            //----------------------  Conclusion page End----------------------
        ]

    })


    try {
        setLoading(true)
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.status === 200) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `${reportName}.docx`);
            });
            setLoading(false)
            return
        }
        if (response.status !== 200) {
            setLoading(false)
            return
        }
        if (response.status === 440) {
            setLoading(false)
            logout()
            toast.error("User logout due to inactivity", {
                position: 'top-right',
                autoClose: 2500,
                pauseOnHover: false,
            })
            return
        }

    } catch (error) {
        console.log(error)
    }
}